// src/pages/BillingReturn.jsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

console.log('[BillingReturn module load] window.location=', window.location.pathname + window.location.search + window.location.hash);

export default function BillingReturn() {
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    console.log('BillingReturn mounted', loc.pathname, loc.search, loc.hash);
    console.log('Router basename=', import.meta.env.VITE_APP_BASE_NAME);

    const id = setTimeout(() => {
      // navigate to dashboard path that honors base name
      const base = (import.meta.env.VITE_APP_BASE_NAME || '').replace(/\/+$/, '');
      const target = base ? `${base}/dashboard` : '/dashboard';
      console.log('BillingReturn navigating to', target);
      window.location.replace(target); // replace vs navigate ensures full reload (useful after payments)
    }, 300);

    return () => clearTimeout(id);
  }, [navigate, loc]);

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2>Finalizing payment…</h2>
      <p>You will be redirected shortly.</p>
    </div>
  );
}
